{
  "de": {
    "posts": {
      "index": {
        "title": "Neuigkeiten von fobizz",
        "empty": "Für diese Sprache gibt es aktuell keine Neuigkeiten.",
        "error": "Die Neuigkeiten konnten nicht geladen werden. Bitte versuche es später erneut.",
        "pinnedAria": "Angepinnter Beitrag",
        "publishedAt": "Veröffentlicht am {date}"
      }
    }
  }
}
